import RootState from '@/types/store/RootState';

const state: RootState = {
  apiKey: '',
  language: 'de',
  offlinePayment: false,
};

export default state;
